import styled from 'styled-components';
import { ReactComponent as MainDuplicateSVG } from 'Images/main-duplicate.svg';
import { ReactComponent as DuplicateSVG } from 'Images/duplicate.svg';
import { ReactComponent as GoTo } from 'Images/icon-goto.svg';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  min-width: 0;
  cursor: ${({ $isQuickPlannerOpen }) => ($isQuickPlannerOpen ? 'grab' : 'default')};

  &:active {
    cursor: ${({ $isQuickPlannerOpen }) => ($isQuickPlannerOpen ? 'grabbing' : 'default')};
  }
`;
Wrapper.displayName = 'Wrapper';

export const Text = styled.p`
  margin: 0 8px 0 0;
  flex: 1 1 auto;
  min-width: 0;
  font-size: 14.5px;
  color: ${({ confirmed, theme }) => (confirmed ? theme.text.tableVulnNameConfirmed : theme.text.tableVulnName)};
  font-weight: ${({ confirmed }) => (confirmed ? '600' : 'normal')};
  cursor: ${({ $isQuickPlannerOpen }) => ($isQuickPlannerOpen ? 'grab' : 'pointer')};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &:active {
    cursor: ${({ $isQuickPlannerOpen }) => ($isQuickPlannerOpen ? 'grabbing' : 'pointer')};
  }
  &:hover {
    text-decoration: underline;
  }
`;
Text.displayName = 'Text';

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  min-width: fit-content;
  overflow: visible;
`;
Actions.displayName = 'Actions';

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const IconWrapper = styled.div`
  width: 19px;
  height: 19px;
  display: inline-flex;
  align-items: center; 
  justify-content: center;
  cursor: default;
  margin: 0;
`;
IconWrapper.displayName = 'IconWrapper';

export const MainDuplicateIcon = styled(MainDuplicateSVG)`
  cursor: default;
  `;
MainDuplicateIcon.displayName = 'DuplicateIcon';

export const DuplicateIcon = styled(DuplicateSVG)`
  cursor: default;
`;
DuplicateIcon.displayName = 'DuplicateIcon';

export const GoToButton = styled.button`
  width: 30px;
  height: 30px;
  padding: 0;
  border: 0;
  background: transparent;
  border-radius: 999px;
  cursor: pointer;

  display: inline-flex;
  align-items: center; 
  justify-content: center;

  &:hover {
    background-color: #dfe5ed;
  }
`;
GoToButton.displayName = 'GoToButton';

export const GoToIcon = styled(GoTo).attrs({
  viewBox: '0 0 38 38',
  preserveAspectRatio: 'xMidYMid meet'
})`
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  overflow: visible;

  path:not([d="M0 0h38v38H0z"]) {
    fill: ${({ theme }) => theme.icons.actionBar.color} !important;
  }
`;
GoToIcon.displayName = 'GoToIcon';
